module.exports = __webpack_public_path__ + "img/tag.e207e415.svg";